import SessionEventProto from "../session-event-proto"
import AiAgent from "../../model2/ai-agent/ai-agent"
import {EVENT_BUS_SESSION_AI_AGENTS_CHANGED} from "./@const"

export default class SessionEvent_AiAgentNew extends SessionEventProto {

    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    process() {
        const agent = new AiAgent(this.data)

        if (gd.session.aiAgents.get(agent.id)) {
            gd.session.aiAgents.get(agent.id)!.applyDelta(this.data)
        } else {
            gd.session.aiAgents.add(agent)
        }

        gd.bus.triggerEvent(EVENT_BUS_SESSION_AI_AGENTS_CHANGED)
    }
}
